import * as Types from "../Constants/AllConstants";

export const GetESolutionsSmsAccountReducer = (state = { account: {} }, action) => {
  switch (action.type) {
    case Types.ESOLUTIONS_SMS_ACCOUNT_REQUEST:
      return { loading: true };
    case Types.ESOLUTIONS_SMS_ACCOUNT_SUCCESS:
      return { loading: false, account: action.payload };
    case Types.ESOLUTIONS_SMS_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateESolutionsSmsAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ESOLUTIONS_SMS_ACCOUNT_UPDATE_REQUEST:
      return { loading: true };
    case Types.ESOLUTIONS_SMS_ACCOUNT_UPDATE_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.ESOLUTIONS_SMS_ACCOUNT_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
